import React from 'react';
import styles from './styles.less';
import { Modal, Button } from 'react-bootstrap';

export class WebGLTest extends React.Component {


	isWebGLAvailable() {
		try {
			const cnv = document.createElement("canvas");
			let gl;
			return !!window.WebGLRenderingContext
				&& (gl = cnv.getContext("webgl") || cnv.getContext("experimental-webgl"))
				&& gl instanceof window.WebGLRenderingContext;
		} catch (e) {
			return false;
		}
	}


    constructor(props, context) {
        super(props, context);
        this.state = {
        	isLoaded: false,
        	isGL: false,
        	show: false
        };
    }

	componentDidMount() {
		const isGL = this.isWebGLAvailable();
		this.setState({
			isLoaded: true,
			isGL: isGL,
			show: !isGL
		})	
	}

	render () {

		if (this.state.isGL || !this.state.show || !this.state.isLoaded ) {
		    return null;
		}

		return (<div className={styles['webgl-test']}>
		  <Modal className={styles['webgl-test']} show={true} onHide={() => this.setState({...(this.state), show: false})} >

		    <Modal.Header closeButton>
		      <Modal.Title>Uh oh: Your browser's WebGL healthcheck failed!</Modal.Title>
		    </Modal.Header>

		    <Modal.Body>
				<p>Most likely, your browser supports WebGL but has it turned off.</p>
	            <p>Potential next steps:</p>
	            <ol>
	                <li>Try another <a href="https://get.webgl.org/">WebGL test</a></li>
                        <li>... and then follow the help link on that page</li>
	                <li>Use the link above to turn on hardware-accelerated rendering in your browser</li>
	                <li>Enable software rendering in your browser in case your GPU hardware is missing or misconfigured</li>
	                <li>Try another browser</li>
	                <li>Send the results of visiting the  <a href="https://webglreport.com/">WebGL Report</a> page to the dedicated <a href="https://www.graphistry.com/support">Graphistry support</a> team for further workarounds</li>
	            </ol>
		    </Modal.Body>

		  </Modal>
		</div>)
	}



}
